import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";

export const UseReportConfirmationPayment = () => {
  const { userPerfil } = useAuthContext();
  const { handleGetAlert } = useLayoutMainContext();
  const { setLoadingGravar } = useConfigPageContext();
  const {
    valueAutoCompGerente,
    valueAutoCompProdutorActive,
    valueAutoCompSupervisor,
  } = UseAutoCompletedAll();

  const { setListReportConfirmationPayment, inputsConfirmationPayment } =
    useContextReportsProduction();

  const typeReport =
    userPerfil?.type_user === "PRODUCER"
      ? "UNIQUE"
      : inputsConfirmationPayment.type_report;

  const funcaoProdutor =
    userPerfil?.type_user === "PRODUCER"
      ? "CORRETOR"
      : inputsConfirmationPayment.funcao_produtor || null;

  const objData = {
    start_date: inputsConfirmationPayment.start_date,
    end_date: inputsConfirmationPayment.end_date,

    type_report: typeReport,
    funcao_produtor: typeReport === "UNIQUE" ? funcaoProdutor : null,

    id_corretor:
      typeReport === "UNIQUE" && funcaoProdutor === "CORRETOR"
        ? userPerfil?.type_user === "PRODUCER"
          ? String(userPerfil.id)
          : String(valueAutoCompProdutorActive.id)
        : "",
    id_supervisor:
      typeReport === "UNIQUE" && funcaoProdutor === "SUPERVISOR"
        ? String(valueAutoCompSupervisor.id)
        : "",
    id_gerente:
      typeReport === "UNIQUE" && funcaoProdutor === "GERENTE"
        ? String(valueAutoCompGerente.id)
        : "",
  };

  const handleGetReportConfirmationPayment = async () => {
    if (!inputsConfirmationPayment.start_date) {
      return handleGetAlert({ message: "Escolha uma data inicial !" });
    }

    if (!inputsConfirmationPayment.end_date) {
      return handleGetAlert({ message: "Escolha uma data final !" });
    }

    if (typeReport === "UNIQUE") {
      if (
        objData.funcao_produtor === "CORRETOR" &&
        objData.id_corretor === ""
      ) {
        return handleGetAlert({
          message: "Escolha um corretor para filtrar !",
        });
      }
      if (
        objData.funcao_produtor === "SUPERVISOR" &&
        objData.id_supervisor === ""
      ) {
        return handleGetAlert({
          message: "Escolha um supervisor para filtrar !",
        });
      }
      if (objData.funcao_produtor === "GERENTE" && objData.id_gerente === "") {
        return handleGetAlert({ message: "Escolha um gerente para filtrar !" });
      }
    }

    setLoadingGravar(true);
    setListReportConfirmationPayment(undefined);

    return api
      .post("/report/payments", objData)
      .then((res) => {
        setListReportConfirmationPayment(res.data);
      })
      .catch((error) => {
        handleGetAlert({ message: error.response.data.message });
      })
      .finally(() => setLoadingGravar(false));
  };

  const handleSubmit = () => handleGetReportConfirmationPayment();

  return { handleSubmit };
};
